import React, {useState} from 'react';
import ButtonList from "../../UIElemtns/Elements/Buttons/ButtonList";
import CheckBoxList from "../../UIElemtns/Elements/CheckBox/CheckBoxList";
import LoaderList from "../../UIElemtns/Elements/Loader/LoaderList";
// import RadioButtons from "../../UIElemtns/Elements/RadioButtons/RadioButtons";
import CardList from "../../UIElemtns/Elements/Card/CardList";
import './sourcecode.scss'
import HeaderList from "../../UIElemtns/Elements/Header/HeaderList";
import Footer from "../../UIElemtns/Elements/Footer/Footer";

const SourceCode = () => {
	const [filter, setFilter] = useState('all');
	const [selectedComponent, setSelectedComponent] = useState(null);
	
	const categories = ['all', 'buttons', 'checkbox', 'loader', 'Cards', 'Header', 'Footer'];
	
	const images = [
		{ id: 1, name: 'buttons', component: <ButtonList />, title: 'Button' },
		{ id: 2, name: 'checkbox', component: <CheckBoxList />, title: 'Checkbox' },
		{ id: 3, name: 'loader', component: <LoaderList />, title: 'Loader' },
		// { id: 4, name: 'Radio Button', component: <RadioButtons />, title: 'Radio Button' },
		{ id: 5, name: 'Cards', component: <CardList />, title: 'Cards' },
		{ id: 6, name: 'Header', component: <HeaderList />, title: 'Header' },
		{ id: 7, name: 'Footer', component: <Footer />, title: 'Footer' },
	];
	
	const handleFilterChange = (category) => {
		setFilter(category);
	};
	
	// const handleComponentDisplay = (component) => {
	// 	setSelectedComponent(component);
	// };
	
	return (
		<div className="MainSourceCode">
			{/* Filter Buttons */}
			<div className="subSourceCode" id="filter-buttons">
				<div className="SourceCode">
					{categories.map((category) => (
						<button
							key={category}
							className={`btn ${filter === category ? 'active' : ''}`}
							onClick={() => handleFilterChange(category)}
						>
							{category.charAt(0).toUpperCase() + category.slice(1)}
						</button>
					))}
				</div>
				
				{/* Filterable Items */}
				<div className="SourceCode-content" id="filterable-cards">
					{images
						.filter((img) => filter === 'all' || img.name === filter)
						.map(({ id, component, title }) => (
							<div key={id} className="ListOfSourceCode" data-name={title}>
								<div className="SourceCode-card-img-top">
									<h3>{title}</h3>
									{component}
								</div>
							</div>
						))}
				</div>
			</div>
			
			{/* Display selected component */}
			{selectedComponent && (
				<div className="selected-component">
					<h3>Selected UI Element:</h3>
					{selectedComponent}
				</div>
			)}
		</div>
	);
};

export default SourceCode;